<div class="modal-header">
  <h5 class="modal-title">
    Ver progreso
    @if (envelopeName || progress?.name) {
      <small class="text-muted d-block">{{ envelopeName || progress?.name }}</small>
    }
  </h5>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  @if (loading) {
    <div class="text-center py-4 text-muted">
      <i class="fas fa-spinner fa-spin mr-2"></i>
      Consultando firmas…
    </div>
  } @else if (errorMessage) {
    <div class="alert alert-danger mb-0">{{ errorMessage }}</div>
  } @else if (progress) {
    <div class="mb-3">
      <span class="badge badge-info">{{ statusLabel(progress.status) }}</span>
      <span class="text-muted small ml-2">
        Firmas: {{ progress.signedCount || 0 }}/{{ progress.totalRecipients || recipients().length }}
      </span>
    </div>

    <p class="fields-title mb-2">Firmantes</p>
    <ul class="list-unstyled progress-list">
      @for (r of recipients(); track r.email || r.recipientId) {
        <li class="progress-item">
          <div>
            <strong>{{ r.name }}</strong>
            <div class="small text-muted">{{ r.email }}</div>
          </div>
          <span class="badge" [class.badge-success]="r.status === 'SIGNED'"
            [class.badge-warning]="r.status === 'PENDING' || r.status === 'IN_PROGRESS'"
            [class.badge-secondary]="r.status === 'REJECTED'">
            {{ statusLabel(r.status) }}
          </span>
        </li>
      }
    </ul>

    @if (progress.updatedAt) {
      <div class="text-muted small mt-3">
        Última actualización: {{ progress.updatedAt | date: 'medium' }}
      </div>
    }
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="load()" [disabled]="loading">
    <i class="fas fa-sync-alt mr-1"></i>
    Actualizar
  </button>
  <button type="button" class="btn btn-primary" (click)="close()">Cerrar</button>
</div>
